<template>
	<div class="basis-page-cls" v-loading="loading">
		<section class="basis-cls_table">
			<div class="table">
				<table-pagination
					pagination
					:data="list"
					:column="column"
					:total="total"
					:page.sync="listQuery.pageNum"
					:limit.sync="listQuery.pageSize"
					@pagination="getList" />
			</div>
		</section>
		<el-drawer
			size="60%"
			:modal="false"
			:modal-append-to-body="false"
			:withHeader="false"
			:visible.sync="drawerKnowledge">
			<KnowInfo v-if="drawerKnowledge" sourceType="Review" :qaId="item.id" :item="item" @drawerKnowInfoClose="drawerKnowledge = false;getList()" />
		</el-drawer>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import KnowInfo from '../components/KnowInfo';
export default {
	components: {KnowInfo},
	computed: {
		...mapGetters([
			'userInfo',
		])
	},
	data() {
		const formatDate = Vue.filter('formatDate');
		return {
			column: [
				{ label: '资源库', prop: 'resourceName' },
				{ 
					label: '标题', 
					minWidth: 180,
					render: (h, scope) => {
                        return <el-link onClick={() => this.handleView(scope.row)} type="primary">{scope.row.q}</el-link>
                    } 
				},
				{ label: '申请人', prop: 'createUserName', minWidth: 180 },
				{ label: '修改原因', prop: 'createRemark', minWidth: 180 },
				{ 
					label: '创建时间', 
					minWidth: 180,
					render: (h, scope) => {
						return <span>{formatDate(scope.row.createTime)}</span>
					} 
				},
				{
                    label: '操作',
                    prop: 'cation',
                    align: 'center',
                    width: 110,
                    fixed: 'right',
                    render: (h, scope) => {
						return (
							<div>
								<el-button 
									onClick={() => this.handleReview(scope.row, 1)}
									type="text">
									通过
								</el-button>
								<el-button 
									onClick={() => this.handleReview(scope.row, 0)}
									type="text">
									不通过
								</el-button>
							</div>
						)
                    }
                }
            ],
			listQuery: {
				pageNum: 1,
				pageSize: 10,
				status: '9'
			},
			total: 0,
			list: [],
			loading: false,
			drawerKnowledge: false,
			item: ''
		}
	},
	async created() {
		await this.getList();
	},
	methods: {
		getList() {
			this.loading = true;
			this.listQuery.projectId = this.$store.getters.userInfo.brandIdentify;
			this.$api.apiPostKnowledgeQATaskList(this.listQuery).then(response => {
				if(response.errcode != 0) {
					this.loading = false;
					return;
				}
				this.list = response.data?.rows ? response.data?.rows : [];
				this.total = response.data?.total ? response.data?.total : 0;
				this.loading = false;
			});
		},
		handleReview(row, status) {
			this.$prompt(`${status == 1 ? '审批通过后，被修改的知识将直接更新生效，请确认。' : ''}`, `${status == 1 ? '确认：是否通过审批' : '审批不通过'}`, {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				showInput: status == 1 ? false : true,
				// inputPattern: status == 1 ? null : /\S/,
				InputType: 'textarea',
				inputPlaceholder: '在此备注不通过原因，方便坐席查看',
				// inputErrorMessage: '请输入不通过原因',
				inputValidator: (value) => {
					if(status != 1) {
						if (value == undefined) {
							return '请输入不通过原因'
						} else if (value.length > 50) {
							return '输入限制在50个字以内'
						}
					}
				}
			}).then(({ value }) => {
				this.$api.apiPostKnowledgeQATaskApproveQAUpd({
					id: row.id,
					status: status,
					auditRemark: value,
					projectId: this.userInfo.brandIdentify
				}).then(response => {
					if(response.errcode != 0) {
						this.loading = false;
						return;
					}
					this.$message({
						type: 'success',
						message: '审批完成'
					});
					this.getList();
				});
			}).catch(() => {
				this.loading = false;
			});
		},
		handleView(row) {
			this.item = row;
			console.log(row)
			this.drawerKnowledge = true;
		}
	}
}
</script>